<template>
  <!-- <span class="borderLine"></span> -->
  <!-- item.status  1为待检测  2为检测中  3为完成  4为未完成-->
  <div
    class="main-foots-card"
    :class="{ detecting1: sampleData.status == 2 }"
    :execute-standardname="sampleData.executionStandardName"
  >
    <div class="sort" v-show="sampleData.sort">第{{ sampleData.sort }}次</div>
    <div class="card-top">
      <!-- <img
        v-if="sampleData.executionStandard.includes('highway')"
        src="../../../assets/mainbottom/gong.svg"
        class="use-standard"
      />
      <img
        v-else-if="sampleData.executionStandard.includes('national')"
        src="../../../assets/mainbottom/guo.svg"
        class="use-standard"
      />
      <img
        v-else-if="sampleData.executionStandard.includes('railway')"
        src="../../../assets/mainbottom/tie.svg"
        class="use-standard"
      />
      <img
        v-else-if="sampleData.executionStandard.includes('hydraulic')"
        src="../../../assets/mainbottom/shui.svg"
        class="use-standard"
      /> -->
      <div
        :class="{
          cardtopnum: sampleData.status == 2,
          cardtopnum1: sampleData.status != 2,
        }"
      >
        <a-tooltip placement="topLeft">
          <template #title>
            <span v-if="sampleData.sampleCode">
              {{
                `${sampleData?.sampleCode?.slice(
                  0,
                  sampleData?.sampleCode.length - 4,
                )}--${sampleData?.sampleCode?.slice(-4)}`
              }}
            </span>
            <span v-else>
              {{
                `${sampleData?.testNumber?.slice(
                  0,
                  sampleData?.testNumber.length - 4,
                )}--${sampleData?.testNumber?.slice(-4)}`
              }}
            </span>
          </template>
          <span class="test-number">
            <span v-if="sampleData.sampleCode">
              {{
                `${sampleData?.sampleCode?.slice(
                  0,
                  sampleData?.sampleCode.length - 4,
                )}--${sampleData?.sampleCode?.slice(-4)}`
              }}
            </span>
            <span v-else-if="sampleData.testNumber">
              {{
                `${sampleData?.testNumber?.slice(
                  0,
                  sampleData?.testNumber.length - 4,
                )}--${sampleData?.testNumber?.slice(-4)}`
              }}
            </span>
            <span v-else>--</span>
          </span>
        </a-tooltip>
      </div>
      <!-- 设备故障显示状态和报告 -->
      <div v-if="sampleData.status === 4" class="cfotstars color3"></div>

      <!-- 完成状态显示报告 -->
      <!-- <div
        v-if="sampleData.status === 3 || sampleData.status === 4"
        class="card-top-right success-color"
      >
        <div class="bottom-status">
          <div
            class="download-report"
            @click="downloadAggregateRecord(sampleData.testNumber)"
          ></div>
        </div>
      </div> -->
      <a-button
        type="primary"
        ghost
        style="margin-left: auto"
        v-if="sampleData.launchEnable && !isCloudPage"
        @click="launchDetection(sampleData)"
      >
        启动
      </a-button>
      <a-button
        type="primary"
        ghost
        danger
        style="margin-left: auto"
        v-if="sampleData.status === 2 && !isCloudPage"
        @click="abandonDetection(sampleData.testNumber)"
      >
        取消
      </a-button>
      <!-- <div
        class="edit"
        v-if="sampleData.launchEnable"
        @click="launchDetection(sampleData)"
      >
        启动
      </div> -->
      <!-- <div
        class="abandon"
        v-if="sampleData.status === 2"
        @click="abandonDetection(sampleData.testNumber)"
      >
        取消
      </div> -->
    </div>
    <div class="divider"></div>
    <div class="card-name">
      {{ sampleData.aggregatesSpecs }}
    </div>
    <div class="card-factory">
      <div class="factory-name">
        <!-- 供应商 -->
        <a-tooltip placement="topLeft">
          <template #title v-if="sampleData.supplierName">
            {{ sampleData.supplierName }}
          </template>
          <div class="factory-text">{{ sampleData.supplierName }}</div>
        </a-tooltip>
      </div>
      <div class="factory-name">
        <!-- 生产商 -->
        <a-tooltip placement="topRight">
          <template #title v-if="sampleData.producerName">
            {{ sampleData.producerName }}
          </template>
          <div class="factory-text2">{{ sampleData.producerName }}</div>
        </a-tooltip>
      </div>
    </div>
    <div class="card-detection">
      <itemStatus
        v-if="sampleData.sampleDetailsMap?.['取样'] !== undefined"
        label="取样"
        :status="sampleData.sampleDetailsMap['取样']"
      />
      <itemStatus
        v-if="sampleData.sampleDetailsMap?.['含水率'] !== undefined"
        label="含水率"
        :status="sampleData.sampleDetailsMap['含水率']"
      />
      <itemStatus
        v-if="sampleData.sampleDetailsMap?.['含泥率'] !== undefined"
        :label="mudContentLabel"
        :status="sampleData.sampleDetailsMap['含泥率']"
      />
      <itemStatus
        v-if="sampleData.sampleDetailsMap?.['颗粒级配'] !== undefined"
        label="颗粒级配-粗"
        :status="sampleData.sampleDetailsMap['颗粒级配']"
      />
      <itemStatus
        v-if="sampleData.sampleDetailsMap?.['细度模数'] !== undefined"
        label="颗粒级配-细"
        :status="sampleData.sampleDetailsMap['细度模数']"
      />
      <!-- MB值 -->
      <itemStatus
        v-if="sampleData.sampleDetailsMap?.['MB值'] !== undefined"
        label="亚甲蓝"
        :status="sampleData.sampleDetailsMap['MB值']"
      />
    </div>
    <!-- 集料检测记录表 -->
    <detectionRecord
      v-if="aggregateRecordShow"
      v-model:visible="aggregateRecordShow"
      ref="aggregateRecordRef"
      :recordData="recordData"
    ></detectionRecord>

    <!-- 启动确认弹窗 -->
    <a-modal
      v-model:visible="confirmVisible"
      :title="sampleAggregateTitle"
      centered
      wrap-class-name="confirm-modal"
      :confirm-loading="confirmLoading"
      @ok="onconfirmLaunch"
      @cancel="onCancel"
      :width="380"
    >
      <div class="modal-content">
        <div class="warning-content">
          <ExclamationCircleOutlined class="warning-icon" />
          {{ sampleAggregateTitle }}
        </div>
        <div>
          <a-form
            name="custom_form"
            ref="modalTitleRef"
            :model="formState"
            :rules="rules"
          >
            <a-row style="width: 100%">
              <a-col :span="24">
                <a-form-item label="车型" name="samplingCode">
                  <a-select
                    v-model:value="formState.samplingCode"
                    :options="vehicleTypeOptions"
                    placeholder="请选择车型"
                    :field-names="fieldNames"
                    @change="vehicleTypeChange"
                  >
                    <!--  -->
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="img-content">
          <a-image
            v-if="vehicleTypeData.carriageImage"
            style="width: 100%; height: 160px; min-height: 160px"
            :src="vehicleTypeData.carriageImage"
            alt="车厢图片"
            fallback="data:image/png;base64,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"
          />
          <div v-else class="empty-img">
            <img src="../../../assets/mainbottom/empty-img.png" alt="" />
          </div>
        </div>
        <div class="detail-size">
          <span style="font-weight: 800">尺寸(m):</span>
          <span> 长{{ vehicleTypeData.carriageLong || "--" }}m</span>
          <span>宽{{ vehicleTypeData.carriageWidth || "--" }}m</span>
          <span> 高{{ vehicleTypeData.carriageHeight || "--" }}m</span>
        </div>
        <div class="detail-remark">
          {{ vehicleTypeData.remark || "" }}
        </div>
        <div class="warning">{{ confirmTitle }}</div>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import {
  h,
  defineProps,
  toRefs,
  onMounted,
  ref,
  watchEffect,
  computed,
} from "vue";
import { apiMainfoots } from "@/api/api-main-foots/api-main-foots.js";
import { message } from "ant-design-vue";
import { Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { createVNode } from "vue";
import detectionRecord from "../menu/detection-record.vue";
import itemStatus from "./item-status.vue";
import { useStore } from "vuex";
let store = useStore();

const props = defineProps({
  sampleData: {
    type: Object,
    require: true,
    default() {
      return {};
    },
  },
  // 如果有取样登记则不能启动样品登记
  sampleDetectionLength: {
    type: Number,
    require: true,
    default() {
      return 0;
    },
  },
});

const isCloudPage = process.env.VUE_APP_ISCLOUDPAGE === "true";
const confirmLoading = ref(false);
let { sampleData, sampleDetectionLength } = toRefs(props);
// console.log('样品每一项',sampleData);
// 集料检测记录表显示
const aggregateRecordShow = ref(false);
// 集料检测记录表testNumber
const recordData = ref({});
// 当前检测标准
let standardCurrent = ref(null);
const confirmVisible = ref(false);
const confirmTitle = ref("");
const sampleAggregateTitle = ref("");
const formState = ref({
  samplingCode: undefined,
});
const vehicleTypeOptions = ref([]);
const vehicleTypeData = ref({});
const rules = {
  // 车辆类型
  samplingCode: [
    {
      required: true,
      trigger: ["blur", "change"],
      message: "请选择车型",
    },
  ],
};
const fieldNames = { label: "name", value: "id" };
const modalTitleRef = ref();
const currentSampleData = ref({});

const mudContentLabel = computed(() => {
  if (
    props.sampleData.aggregatesSpecs.includes("机制砂") ||
    props.sampleData.aggregatesSpecs.includes("混合砂")
  ) {
    return "石粉含量";
  } else if (props.sampleData.aggregatesSpecs.includes("碎石")) {
    return "泥粉含量";
  } else {
    return "含泥量";
  }
});

/**
 * @name 郭冲
 * @Date 2023-05-26 10:10:28
 * @introduction 监听器-监听vuex里的detecttionStandard的变化
 * @description 当变化的时候重新赋值给组件内的standardCurrent
 * @return 无返回类型
 * @exception [违例类型] [违例类型说明]
 */
watchEffect(() => {
  standardCurrent.value = store.state.device.detectionStandard;
});

onMounted(() => {});
/**
 * @name 郭冲
 * @Date 2023-07-18 16:52:47
 * @introduction 下载检测记录表
 * @description 详细描述
 * @param {Number} id 需要下载的记录表id
 * @return {返回类型说明}
 * @exception [违例类型] [违例类型说明]
 */
// const downloadAggregateRecord = () => {
//   aggregateRecordShow.value = true;
//   Object.assign(recordData.value, sampleData.value);

// };
/**
 * @name 郭冲
 * @Date 2023-08-30 11:30:46
 * @introduction 启动检测
 * @description 详细描述
 * @param {String | Number} testNumber 检测编号
 * @return {返回类型说明}
 * @exception [违例类型] [违例类型说明]
 */
const launchDetection = async (sampleData) => {
  // samplingManual为1代表手动取样登记，samplingSwitch为1代表地磅取样登记
  // 地磅取样登记的没有启动按钮，不会走这个函数
  if (sampleData.samplingManual == 1) {
    confirmVisible.value = true;
    currentSampleData.value = sampleData;
    confirmTitle.value = "请确认车辆是否停靠到位，确定后将启动取样钻头?";
    sampleAggregateTitle.value = sampleData.aggregatesSpecs;
    let res = await apiMainfoots.getVhicleList();
    vehicleTypeOptions.value = res.data.data;
  } else {
    Modal.confirm({
      title: sampleData.aggregatesSpecs,
      icon: createVNode(ExclamationCircleOutlined),
      content: createVNode(
        "div",
        {
          style: "color:red;font-size:0.09rem;",
        },
        `${"请确认检测设备状态是否全部准备就绪?"}`,
      ),
      maskClosable: true,
      style: `top:50%`,
      onOk() {
        confirmLoading.value = true;
        let params = {
          testNumber: sampleData.testNumber,
        };
        // console.log(params);
        if (sampleDetectionLength.value == 0) {
          apiMainfoots
            .launchDetection(params)
            .then(() => {
              confirmLoading.value = false;
              message.success("启动检测成功", 2);
            })
            .catch((error) => {
              // 处理请求错误
              confirmLoading.value = false;
              console.error(error);
              message.error(`启动检测失败-${error.data.message}`, 2);
            });
        } else {
          message.error("等待取样登记检测完后才可启动", 2);
        }
      },
      onCancel() {
        // console.log('Cancel');、、
      },
      class: "test",
    });
  }
};
const onconfirmLaunch = async () => {
  console.log("confirm");
  let valid;
  try {
    valid = await modalTitleRef.value.validate();
  } catch (error) {
    message.error("请选择车型");
  }
  if (!valid) return;

  confirmLoading.value = true;
  let params = {
    testNumber: currentSampleData.value.testNumber,
    samplingCode: vehicleTypeData.value.samplingCode,
  };
  apiMainfoots
    .launchDetection(params)
    .then(() => {
      confirmLoading.value = false;
      confirmVisible.value = false;
      message.success("启动检测成功", 2);
    })
    .catch((error) => {
      // 处理请求错误
      confirmLoading.value = false;
      console.error(error);
      message.error(`启动检测失败-${error.data.message}`, 2);
    });
};
const onCancel = async () => {
  formState.value = {
    samplingCode: undefined,
  };
  vehicleTypeData.value = {};
  await modalTitleRef.value.resetFields();
  confirmVisible.value = false;
};
const vehicleTypeChange = (e) => {
  if (e) {
    vehicleTypeData.value =
      vehicleTypeOptions.value.filter((item) => item.id == e)?.[0] || [];
  }
};
/**
 * @name 郭冲
 * @Date 2023-10-24 10:09:52
 * @introduction 取消检测
 * @description 详细描述
 * @param {String|Number} testNumber 检测单号
 * @return {返回类型说明}
 * @exception [违例类型] [违例类型说明]
 */
const abandonDetection = (testNumber) => {
  Modal.confirm({
    title: sampleData.value.aggregatesSpecs,
    icon: createVNode(ExclamationCircleOutlined),
    content: createVNode(
      "div",
      {
        style: "color:red;font-size:0.09rem;",
      },
      `确定取消检测？`,
    ),
    maskClosable: true,
    style: `top:50%`,
    onOk() {
      let params = {
        testNumber: testNumber,
      };
      apiMainfoots
        .abandonDetection(params)
        .then(() => {
          message.success("取消检测成功", 2);
        })
        .catch((error) => {
          // 处理请求错误
          console.error(error);
          message.error(`取消检测失败-${error.data.message}`, 2);
        });
    },
    onCancel() {
      // console.log('Cancel');
    },
    class: "test",
  });
};
</script>

<style lang="scss" scoped>
@import "../../../../static/font.css";
.modal-content {
  // background-color: #dfdfdf;
  width: 100%;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  color: white;
  font-size: 0.08rem;
}
.warning-content {
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 6%;
  font-size: 0.09rem;
  font-weight: 800;
  margin-bottom: 0.1rem;
}
.warning-icon {
  color: #faad14;
  font-size: 0.13rem;
  font-weight: 800;
}
.img-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #74747470;
}
.empty-img {
  width: 100%;
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.empty-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.detail-size {
  display: flex;
  column-gap: 5%;
  margin-top: 10px;
}
.detail-remark {
  margin: 10px 0px;
}
.aggregate {
  // font-size: 0.09rem;
}
.warning {
  color: #ff5a5a;
  font-size: 0.09rem;
  padding: 0 5px;
  line-height: 30px;
  background-color: #1b304f;
}
:deep(.ant-image-mask) {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
:deep(.ant-form-item-required) {
  color: white !important;
}
:deep(.ant-modal-body) {
  background-color: #fcfcfc !important;
}
:deep(.ant-form-item-required) {
  color: black;
}
:deep(.ant-modal-confirm-body .ant-modal-confirm-title) {
  font-size: 0.07rem;
}

:deep(.ant-btn) {
  box-sizing: border-box;
  width: 0.25rem;
  height: 0.12rem;
  font-size: 0.06rem;
  padding: 0.04rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
:deep(.ant-btn-primary) {
  box-shadow: 0px 0px 3px #16dee9;
}
:deep(.ant-btn-dangerous) {
  box-shadow: 0px 0px 3px #ff4d4f;
}
.divider {
  width: 100%;
  height: 8%;
  /* border: #ec2745 1px solid; */
  background-image: url("../../../assets/mainbottom/sample-divider.png");
  background-repeat: no-repeat;
  background-position: 0 center;
  background-size: cover;
}
// .edit,
// .abandon {
//   cursor: pointer;
//   font-size: 0.07rem;
//   color: white;
//   width: 0.38rem;
//   height: 0.25rem;
//   margin-left: auto;
//   display: block;
//   background-image: url('../../../assets/mainbottom/launch.svg');
//   background-repeat: no-repeat;
//   background-size: contain;
//   background-position: center;
//   text-align: center;
//   line-height: 0.25rem;
//   transform: scale(1.1);
// }
// .abandon {
//   background-image: url('../../../assets/mainbottom/cancel.svg');
// }

.waiting {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  flex: 1;
}
.waiting-detection {
  width: 90%;
  color: #e7a10b;
  line-height: 0.15rem;
  border: solid 1px#e7a10b;
  text-align: center;
  border-radius: 0.02rem;
}
.cheking-detection {
  width: 90%;
  color: #1afa29;
  line-height: 0.15rem;
  border: solid 1px#1afa29;
  text-align: center;
  border-radius: 0.02rem;
}
.ant-pagination-total-text,
.ant-pagination-options-quick-jumper {
  color: #fff !important;
}
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
.sample-list {
  min-width: 720px !important;
}

.main-foots-card {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  padding: 0rem 0.1rem;
  height: 95%;
  box-shadow: 0px 0px 24px rgba(190, 190, 190, 0.048),
    0px 0px 50px rgba(202, 202, 202, 0.079);
  background-color: rgba(1, 1, 1, 0.2);
  border-radius: 2px;
  .sort {
    position: absolute;
    bottom: 0.02rem;
    left: 0.1rem;
    color: #cbcbcb7a;
    font-size: 0.1rem;
    font-weight: bold;
  }
}
.main-foots-card::after {
  display: block;
  content: attr(execute-standardname);
  position: absolute;
  bottom: 0.02rem;
  right: 0.05rem;
  color: #cbcbcb2a;
  font-size: 0.14rem;
  font-weight: bold;
}
.detecting {
  background-image: url("../../../assets/load.gif");
  background-repeat: no-repeat;
  background-position: 40.8% 61%;
  background-size: 113.3% 125%;
}
.detecting1 {
  background-image: url("../../../assets/loading.gif");
  background-repeat: no-repeat;
  background-position: 49% 76%;
  background-size: 109.5% 113.5%;
  background-color: rgba(192, 192, 192, 0.2);
  animation: highlight 2.5s linear infinite;
}

@keyframes highlight {
  0% {
    background-color: rgba(1, 1, 1, 0.2);
  }

  50% {
    background-color: rgba(0, 0, 0, 0.4);
  }

  100% {
    background-color: rgba(1, 1, 1, 0.2);
  }
}
.main-foots-card .border-box-content {
  padding: 0.1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.cheking {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.cfotstars {
  width: 0.08rem;
  height: 0.08rem;
  border-radius: 50%;
  margin: 0rem 0.04rem;
}
.color1 {
  background: #00ff00;
}
.color2 {
  background: #fab421;
}
.color3 {
  background: #ec2745;
}
.cfotstars-warn {
  font-size: 0.1rem;
  color: #ec2745;
  margin-right: 10px;
}
.twinkle {
  animation: star 1.2s linear infinite;
  box-shadow: 0px 0px 10px #00ff00;
}
.twinklewr {
  animation: star 1.2s linear infinite;
}
@keyframes star {
  0% {
    opacity: 0.6;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.2);
  }

  100% {
    opacity: 0.6;
    transform: scale(1);
  }
}

.card-top {
  height: 10%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 0.05rem;
  /* border: #ec2745 1px solid; */
  .use-standard {
    max-width: 0.11rem;
    max-height: 0.137rem;
    margin-right: 0.03rem;
  }
  .test-number {
    width: 77%;
    font-size: 0.09rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.cardtopnum,
.cardtopnum1 {
  // display: flex;
  // flex-direction: row;
  // justify-content: flex-start;
  // align-items: center;

  font-family: "PangMenZhengDao", sans-serif;
  font-weight: 400;
  color: #f3c576;
  height: 100%;
  // min-width: 85%;
}
.cardtopnum1 {
  color: #ffffff;
}
.card-top-right {
  display: flex;
  align-items: center;
  margin-left: auto;
  font-size: 0.07rem;
}
.card-name {
  font-size: 0.08rem;
  margin-top: 0.02rem;
  color: #fff;
  height: 10%;
  padding: 0rem 0.05rem 0rem 0.03rem;
}
.card-factory {
  font-size: 0.08rem;
  margin-top: 0.02rem;
  padding-left: 0.03rem;
  color: #fff;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2%;
  .factory-name {
    width: 49%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .factory-text {
    width: 100%;
    white-space: nowrap; /* 防止换行 */
    overflow: hidden; /* 隐藏溢出部分 */
    text-overflow: ellipsis; /* 显示省略号 */
  }
  .factory-text2 {
    width: 100%;
    white-space: nowrap; /* 防止换行 */
    overflow: hidden; /* 隐藏溢出部分 */
    text-overflow: ellipsis; /* 显示省略号 */
    text-align: right;
    // display: flex;
    // flex-direction: row;
    // justify-content: flex-end;
    // align-items: center;
  }
}
.card-detection {
  height: 40%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 0.03rem;
  padding: 0rem 0.03rem;
}
.card-detection-left {
  width: 50%;
  /* padding-right: 0.08rem; */
}
.card-detection-right {
  width: 50%;
  /* padding-left: 0.08rem; */
}
.btns {
  font-size: 0.07rem;
  color: #fff;
  background: rgb(0, 183, 255, 0.4);
  border: 1px solid rgb(0, 183, 255);
  padding: 0.02rem 0.08rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.02rem;
  width: 0.45rem;
  cursor: pointer;
}
.btns .bticon {
  font-size: 0.08rem;
  margin-left: 0.04rem;
}
.merrors {
  font-size: 0.07rem;
  color: #ec2745;
}
.main-foots-right {
  padding: 0.03rem 0.06rem;
  box-sizing: border-box;
  margin-bottom: 0.03rem;
  border: 1px solid rgb(0, 183, 255, 0.4);
  /* background: radial-gradient( rgba(15, 92, 151,0.5), rgba(255, 255, 255,0.2)); */
  box-shadow: rgba(15, 92, 151, 0.4) 0px 0px 0.2rem inset;
  color: #fff;
  font-size: 0.08rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.main-foots-right .ricon {
  font-size: 0.1rem;
  margin-bottom: 0.06rem;
}
.ant-form-item-label > label {
  color: #fff;
}
.bottom-status {
  flex: 1;
  text-align: right;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.download-report {
  width: 0.12rem;
  height: 0.12rem;
  cursor: pointer;
  background-image: url("../../../assets/mainbottom/download.png");
  background-repeat: no-repeat;
  background-position: 0% 0%;
  background-size: 100%;
}
.download-report:hover {
  background-image: url("../../../assets/mainbottom/download_hover.png");
}
:deep(.ant-pagination-item-ellipsis) {
  color: #fff !important;
}
</style>
